import { postData, getData, deleteData } from 'helpers/apiHelper'
import { MAIN_PATH_DOCUMENTS, DOCUMENT_LIST, DOCUMENT_ADD, DOCUMENT_DELETE, FILE_MANAGER_DATA } from './apiPath'
import { getDocument, addDocument, deleteDocument, fileManagerData } from 'store/actions/documents';
import { pickBy } from "lodash";

//get
export function getDocumentList(value, callback) {
  let url = `${MAIN_PATH_DOCUMENTS}${DOCUMENT_LIST}`;
  return (dispatch) => postData(url, value)
    .then((data) => {
      dispatch(getDocument(data, callback));
      return data;
    });
}

//add
export function addDocumentData(value, callback) {
  return (dispatch) => postData(`${MAIN_PATH_DOCUMENTS}${DOCUMENT_ADD}`, value)
    .then((data) => {
      dispatch(addDocument(data, callback));
      return data;
    });
}


//delete
export function deleteDocumentData(value) {
  return (dispatch) => postData(`${MAIN_PATH_DOCUMENTS}${DOCUMENT_DELETE}${value}`)
    .then((data) => {
      dispatch(deleteDocument(data));
      return data;
    });
}


// file manager
export function getFileManagerData(module, params) {
  let url = `${MAIN_PATH_DOCUMENTS}${FILE_MANAGER_DATA}/${module}`;
  return (dispatch) => getData(url, { params: pickBy(params) })
    .then((data) => {
      dispatch(fileManagerData(data));
      return data;
    });
}